import { useLang } from '@/i18n';
import EcoTextTc from 'eco-design/sections/eco-text-tc';
import styles from './index.module.scss';
export default function Comp() {
    const { t } = useLang('theProduct.FooterTcA');
    const items = [
        {
            isHead: true,
            title: t('head1'),
        },
        {
            title: t('titleA1'),
        },
        {
            title: t('titleA1'),
        },
        {
            isHead: true,
            title: t('head1'),
        },
        {
            title: t('titleA1'),
            desc: t('descA1'),
        },
    ];
    return (
        <>
            <EcoTextTc items={items} className={styles.comp} />
        </>
    );
}
